import Image from "next/image";
import style from "./vinteoBanner.module.scss";

const VinteoBannerSmall = () => {
  return (
    <a href="https://vinteo.ai?utm_source=bgrem&&utm_medium=banner&utm_content=servis_banner" target="_blank" rel="noreferrer" className={style.vinteoBannerSmall}>
      <Image className={style.vinteoBannerImg} src="/vinteo/img.png" alt="vinteoBanner" width={409} height={154} />
      <h3 className={style.vinteoBannerTitle}>Generate AI product photos in realistic interiors</h3>
      <div className={style.vinteoBannerBtn}>Explore</div>
    </a>
  )
}

const VinteoBannerBig = () => {
  const type = Math.random() < 0.5


  return (
    <a href={`https://vinteo.ai?utm_source=bgrem&utm_medium=banner&utm_content=landing_banner_${type}`} target="_blank" rel="noreferrer" className={style.vinteoBannerBig}>
      <div className={style.vinteoBannerContent}>
        <div className={style.vinteoBannerTypeWrapper}>
          <Image className={style.vinteoBannerImg} src="/vinteo/logo.png" alt="vinteo logo" width={108} height={18} loading="lazy" />
          <span className={style.vinteoBannerType}>B2B</span>
        </div>
        <h3 className={style.vinteoBannerTitleBig}>AI Product Photos in realistic interiors</h3>
        <div className={style.vinteoBannerBtn}>Explore</div>
      </div>
      {type ?
        <div className={style.vinteoBannerImgWrapperTypeOne}>
          <Image className={style.vinteoBannerTypeOneImg} src="/vinteo/img1.png" alt="vinteoBanner img 1" width={340} height={200} loading="lazy" />
          <Image className={style.vinteoBannerTypeOneImg} src="/vinteo/img2.png" alt="vinteoBanner img 2" width={340} height={200} loading="lazy" />
          <Image className={style.vinteoBannerTypeOneImg} src="/vinteo/img3.png" alt="vinteoBanner img 3" width={340} height={200} loading="lazy" />
        </div>
        :
        <div className={style.vinteoBannerImgWrapperTypeTwo}>
          <div className={style.vinteoBannerImgTypeTwo} >
            <Image src="/vinteo/imgTypeTwo.png" alt="vinteoBanner img" width={695} height={240} loading="lazy" />
          </div>

          <Image className={style.vinteoBannerCard} src="/vinteo/img-card.png" alt="vinteoBanner img 2" width={210} height={267} loading="lazy" />
        </div>
      }

    </a>
  )
}

export { VinteoBannerSmall, VinteoBannerBig }